import { Injectable,OnInit } from '@angular/core';

// Modelos
import { MenuItem } from '../models/menu.model';
import { SharedService } from 'src/app/core/services/shared.service';

import { MenuEvent } from 'src/app/core/services/menuevent.service';

@Injectable({
  providedIn: 'root'
})
 
export class MenuService  implements OnInit { 

  MENU: MenuItem[] = [];
  menu: any[] = this.MENU;

  constructor(  private dataService: SharedService,
                private menuEvent: MenuEvent) {
      this.menu = this.MENU;
  }

  ngOnInit () {
      this.menu = this.MENU;
  }


  getMenu(){
    return this.MENU;
  }

  setMenu(NewMenu){
    this.MENU  = NewMenu;
    this.menuEvent.broadcast('REFRESCAR_MENU', JSON.parse("{ }"));      
  }
}
